
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import logo from './logo.png'; // Import the logo


const FinancialDashboard = () => {
    const [analyst, setAnalyst] = useState('');
    const [output, setOutput] = useState('');
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [metrics, setMetrics] = useState({});
    const [newMetrics, setNewMetrics] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [showMetrics, setShowMetrics] = useState({});
    const [isLoadingMetrics, setIsLoadingMetrics] = useState({});
    const [searchQuery, setSearchQuery] = useState({});
    const [searchResults, setSearchResults] = useState({});
    const [isSearching, setIsSearching] = useState({});
    const [company, setCompany] = useState('');
    const [dataLoaded] = useState(false);
    const [rowLabels, setRowLabels] = useState([]);

    useEffect(() => {
        if (company === 'ADBE US') {
            setRowLabels([
                { label: "Revenue Build", isBold: true },
                { label: "Creative Revenue, mm" },
                { label: "Document Cloud Revenue, mm" },
                { label: "Digital Media Revenue, mm" },
                { label: "Digital Experience Revenue, mm" },
                { label: "Publishing and Advertising Revenue, mm" },
                { label: "Total Revenue, mm" },
                { label: "Income Statement", isBold: true },
                { label: "Net Revenue" },
                { label: "Non-GAAP Gross Profit" },
                { label: "Non-GAAP R&D" },
                { label: "Non-GAAP S&M" },
                { label: "Non-GAAP G&A" },
                { label: "Non-GAAP Operating Income Before Other" },
                { label: "Non-GAAP Earnings before Taxes" },
                { label: "Non-GAAP Net Income to common shareholders" },
                { label: "Non-GAAP Adjusted Earnings Per Share - WAD" },
                { label: "Adjusted Shares Outstanding - WAD" },
                { label: "Margin Analysis", isBold: true },
                { label: "Digital Media Gross Profit Margin, %" },
                { label: "Digital Experience Gross Profit Margin, %" },
                { label: "Publishing and Advertising Gross Profit Margin, %" },
                { label: "Total Gross Profit Margin, %" },
                { label: "Non-GAAP Gross Margin, %" },
                { label: "Non-GAAP R&D Margin, %" },
                { label: "Non-GAAP S&M Margin, %" },
                { label: "Non-GAAP G&A Margin, %" },
                { label: "Non-GAAP Operating Income Margin, %" },
                { label: "Company Reported Non-GAAP Operating Income Margin, %" },
                // { label: "Cash Flow Statement", isBold: true },
                // { label: "Cash Flow Per Diluted Share" },
                // { label: "Capex" },
                // { label: "Acquisitions" },
                // { label: "Divestiture" },
                // { label: "Deferred Revenue" },
                // { label: "Dividend Paid" },
                // { label: "Dividend Per Share" },
                // { label: "Net Debt Issuance (Repayment)" },
                // { label: "Net Share Issuance (Buybacks)" },
                // { label: "FCF, Post Div, Debt, Buyback, A/D" },
                // { label: "Balance Sheet", isBold: true },
                // { label: "Cash" },
                // { label: "ST Debt" },
                // { label: "LT Debt" },
                // { label: "Debt" },
                // { label: "Operating Lease Liabilities" },
                // { label: "Net Debt" }
            ]);
        } else if (company === 'DE US') {
            setRowLabels([
                { label: "Revenue Build", isBold: true },
                { label: "Production & Precision Ag net revenue, mm" },
                { label: "Small Ag & Turf net revenue, mm" },
                { label: "Agriculture and Turf net revenue, mm" },
                { label: "Construction and Forestry net revenue, mm" },
                { label: "Total Equipment net revenue, mm" },
                { label: "Financial Services revenue, mm" },
                { label: "Other revenues, mm" },
                { label: "Total Revenue, mm" },
                { label: "Income Statement", isBold: true },
                { label: "Net Revenue" },
                { label: "Gross Profit" },
                { label: "R&D" },
                { label: "SG&A" },
                { label: "Other OPEX"},
                { label: "Adj. EBIT" },
                { label: "Adj. EBITDA" },
                { label: "EBT" },
                { label: "Adjusted Net Income (Loss)" },
                { label: "Adjusted EPS" },
                { label: "Adjusted Shares Outstanding - WAD" },
                { label: "Margin Analysis", isBold: true },
                { label: "Gross Margin" },
                { label: "R&D margin, %" },
                { label: "SG&A margin, %" },
                { label: "Other OPEX margin, %" },
                { label: "Adjusted EBIT Margin (No Adjustments), %" },
                { label: "Adjusted EBITDA Margin (No Adjustments), %" },
                { label: "Production & Precision Ag Margin" },
                { label: "Small Ag & Turf Margin" },
                { label: "Agriculture and Turf Margin" },
                { label: "Construction and Forestry Margin" },
                { label: "Total Equipment Margin" },
                { label: "Financial Services Margin" },
                { label: "Total operating profit margin" },
                { label: "Cash Flow Statement", isBold: true },
                { label: "Cash Flow Per Diluted Share" },
                { label: "Capex" },
                { label: "Acquisitions" },
                { label: "Divestiture" },
                { label: "Dividend Paid" },
                { label: "Dividend Per Share" }, 
                { label: "Net Debt Issuance (Repayment)" },
                { label: "Net Share Issuance (Buybacks)" },
                { label: "SBC expense" },
                { label: "FCF, Post Div, Debt, Buyback, A/D" },
                { label: "Balance Sheet", isBold: true },
                // { label: "Cash" },
                { label: "ST Debt" },
                { label: "LT Debt" },
                { label: "Debt" },
                { label: "Net Debt" }
            ]);
        } else {
            setRowLabels([]); // Clear labels if neither ADBE US nor DE US
        }
        setData(null); // Clear existing data when company changes
    }, [company]);


  const columns = [
    { label: ['Before', '3Q24E'], key: 'beforeProjected3Q24E' },
    { label: ['After', '3Q24'], key: 'afterProjected3Q24' },
    { label: ['Delta', '3Q24E'], key: 'delta3Q24E' },
    { label: ['Before', '4Q24E'], key: 'beforeProjected4Q24E' },
    { label: ['After', '4Q24E'], key: 'afterProjected4Q24E' },
    { label: ['Delta', '4Q24E'], key: 'delta4Q24E' },
    { label: ['Before', '2024E'], key: 'beforeProjected2024E' },
    { label: ['After', '2024E'], key: 'afterProjected2024E' },
    { label: ['Delta', '2024E'], key: 'delta2024E' },
    { label: ['Before', '2025E'], key: 'beforeProjected2025E' },
    { label: ['After', '2025E'], key: 'afterProjected2025E' },
    { label: ['Delta', '2025E'], key: 'delta2025E' },
    { label: ['Before', '2026E'], key: 'beforeProjected2026E' },
    { label: ['After', '2026E'], key: 'afterProjected2026E' },
    { label: ['Delta', '2026E'], key: 'delta2026E' },
  ];


const fetchData = async () => {
    if (!company || !analyst) {
        alert('Please enter both Company and Analyst');
        return;
    }

    setIsLoading(true);
    const newData = {};

    const API_URL = 'https://tiger-dashboard-server-b0dfb7ddbcfbgnfs.eastus-01.azurewebsites.net/query';

    try {
        for (const row of rowLabels) {
            if (!row.isEmpty && !row.isBold) {
                newData[row.label] = {};
                for (const col of columns) {
                    const [beforeAfter, date] = col.label;
                    
                    if (beforeAfter === 'Delta') continue;

                    const version = beforeAfter === 'Before' ? 1 : 2;

                    try {
                        const response = await axios.post(API_URL, {
                            company: company,
                            date: date,
                            metric_description: row.label,
                            version: version,
                            analyst: analyst,
                            output: output
                        }, {
                            withCredentials: false,
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        });

                        if (response.data && response.data[output] !== undefined) {
                            newData[row.label][col.key] = response.data[output];
                            // Update the state immediately after each fetch
                            setData(prevData => ({
                                ...prevData,
                                [row.label]: {
                                    ...(prevData?.[row.label] || {}),
                                    [col.key]: response.data[output]
                                }
                            }));
                        }
                    } catch (error) {
                        console.error('Error for specific request:', error);
                        if (error.response && error.response.status === 404) {
                            console.log(`No data found for ${row.label} on ${date}`);
                            newData[row.label][col.key] = 'N/A';
                            // Update the state with N/A
                            setData(prevData => ({
                                ...prevData,
                                [row.label]: {
                                    ...(prevData?.[row.label] || {}),
                                    [col.key]: 'N/A'
                                }
                            }));
                        } else {
                            throw error;
                        }
                    }
                }
            }
        }

        // Calculate delta values after all data is fetched
        if (output === 'value') {
            for (const row of rowLabels) {
                if (!row.isEmpty && !row.isBold && newData[row.label]) {
                    for (let i = 0; i < columns.length; i += 3) {
                        const beforeKey = columns[i].key;
                        const afterKey = columns[i + 1].key;
                        const deltaKey = columns[i + 2].key;

                        const beforeValue = parseFloat(newData[row.label][beforeKey]);
                        const afterValue = parseFloat(newData[row.label][afterKey]);

                        let deltaValue;
                        if (!isNaN(beforeValue) && !isNaN(afterValue) && beforeValue !== 0) {
                            const percentageDelta = ((afterValue - beforeValue) / beforeValue * 100);
                            deltaValue = percentageDelta.toFixed(1) + '%';
                        } else if (!isNaN(beforeValue) && !isNaN(afterValue) && beforeValue === 0 && afterValue !== 0) {
                            deltaValue = 'Inf%';
                        } else if (!isNaN(beforeValue) && !isNaN(afterValue) && beforeValue === 0 && afterValue === 0) {
                            deltaValue = '0.0%';
                        } else {
                            deltaValue = 'N/A';
                        }

                        newData[row.label][deltaKey] = deltaValue;
                        // Update the state with the calculated delta
                        setData(prevData => ({
                            ...prevData,
                            [row.label]: {
                                ...(prevData?.[row.label] || {}),
                                [deltaKey]: deltaValue
                            }
                        }));
                    }
                }
            }
        }

    } catch (error) {
        console.error('Error fetching data:', error);
        alert('An error occurred while fetching data. Please check the console for more details.');
    } finally {
        setIsLoading(false);
    }
};

const fetchMetrics = async (category) => {
    console.log('Fetching metrics with inputs:');
    console.log('Category:', category);
    console.log('Company:', company);
    console.log('Analyst:', analyst);

    if (!company || !analyst) {
        console.warn('Company or analyst is missing');
        alert('Please select both Company and Analyst');
        return;
    }

    setIsLoadingMetrics(prev => ({ ...prev, [category]: true }));

    const url = `https://tiger-dashboard-server-b0dfb7ddbcfbgnfs.eastus-01.azurewebsites.net/fetch-metrics?category=${encodeURIComponent(category)}&analyst=${encodeURIComponent(analyst)}&company=${encodeURIComponent(company)}`;
    console.log('Fetching metrics from URL:', url);

    try {
        const response = await axios.get(url, {
            withCredentials: false
        });

        console.log('Response data:', response.data);

        setMetrics(prevMetrics => ({
            ...prevMetrics,
            [category]: response.data.metrics || []
        }));
        setShowMetrics(prevShow => ({
            ...prevShow,
            [category]: true
        }));
    } catch (error) {
        console.error('Error fetching metrics:', error);
        // ... (error handling)
        alert('An error occurred while fetching metrics. Please check the console for more details.');
    } finally {
        setIsLoadingMetrics(prev => ({ ...prev, [category]: false }));
    }
};

const addMetric = (category, metric) => {
    setRowLabels(prevLabels => {
        const newLabels = [...prevLabels];
        const categoryIndex = newLabels.findIndex(row => row.label === category && row.isBold);
        if (categoryIndex !== -1) {
            let insertIndex = categoryIndex + 1;
            while (insertIndex < newLabels.length && 
                   !newLabels[insertIndex].isBold && 
                   !newLabels[insertIndex].isEmpty) {
                insertIndex++;
            }
            newLabels.splice(insertIndex, 0, { label: metric, category, isNew: true });
        }
        return newLabels;
    });
    setShowMetrics(prevShow => ({
        ...prevShow,
        [category]: false
    }));
    setNewMetrics(prev => [...prev, { category, metric }]);
    
    // Initialize the new metric with empty data
    setData(prevData => ({
        ...prevData,
        [metric]: {}
    }));
};

const removeMetric = (metricToRemove) => {
    setRowLabels(prevLabels => prevLabels.filter(row => row.label !== metricToRemove));
    setNewMetrics(prev => prev.filter(({ metric }) => metric !== metricToRemove));
    setData(prevData => {
        const newData = { ...prevData };
        delete newData[metricToRemove];
        return newData;
    });
};

const updateData = async () => {
    if (!company || !analyst || newMetrics.length === 0) {
        alert('Please select both Company and Analyst, and add new metrics before updating');
        return;
    }

    setIsUpdating(true);
    const updatedData = { ...data };

    const API_URL = 'https://tiger-dashboard-server-b0dfb7ddbcfbgnfs.eastus-01.azurewebsites.net/query-exact';

    try {
        for (const { metric } of newMetrics) {
            for (const col of columns) {
                const [beforeAfter, date] = col.label;
                
                if (beforeAfter === 'Delta') continue;

                const version = beforeAfter === 'Before' ? 1 : 2;

                try {
                    const response = await axios.post(API_URL, {
                        company: company,
                        date: date,
                        metric_description: metric,
                        version: version,
                        analyst: analyst,
                        output: output
                    }, {
                        withCredentials: false,
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });

                    if (response.data && response.data[output] !== undefined) {
                        if (!updatedData[metric]) updatedData[metric] = {};
                        updatedData[metric][col.key] = response.data[output];
                    }
                } catch (error) {
                    console.error('Error for specific request:', error);
                    if (!updatedData[metric]) updatedData[metric] = {};
                    updatedData[metric][col.key] = 'N/A';
                }
            }
        }

        // Calculate absolute percentage delta values for new metrics
        if (output === 'value') {
            for (const { metric } of newMetrics) {
                if (updatedData[metric]) {
                    for (let i = 0; i < columns.length; i += 3) {
                        const beforeKey = columns[i].key;
                        const afterKey = columns[i + 1].key;
                        const deltaKey = columns[i + 2].key;

                        const beforeValue = parseFloat(updatedData[metric][beforeKey]);
                        const afterValue = parseFloat(updatedData[metric][afterKey]);

                        if (!isNaN(beforeValue) && !isNaN(afterValue) && beforeValue !== 0) {
                            const percentageDelta = ((afterValue - beforeValue) / beforeValue * 100);
                            updatedData[metric][deltaKey] = percentageDelta.toFixed(1) + '%';
                        } else if (!isNaN(beforeValue) && !isNaN(afterValue) && beforeValue === 0 && afterValue !== 0) {
                            updatedData[metric][deltaKey] = 'Inf%';
                        } else if (!isNaN(beforeValue) && !isNaN(afterValue) && beforeValue === 0 && afterValue === 0) {
                            updatedData[metric][deltaKey] = '0.0%';
                        } else {
                            updatedData[metric][deltaKey] = 'N/A';
                        }
                    }
                }
            }
        }

        setData(updatedData);
        setNewMetrics([]); // Clear the new metrics after updating
    } catch (error) {
        console.error('Error updating data:', error);
        alert('An error occurred while updating data. Please check the console for more details.');
    } finally {
        setIsUpdating(false);
    }
};


const hideMetrics = (category) => {
    setShowMetrics(prevShow => ({
        ...prevShow,
        [category]: false
    }));
};

const handleSearchQueryChange = (category, query) => {
    setSearchQuery(prev => ({ ...prev, [category]: query }));
};

const searchMetrics = async (category) => {
    if (!company || !analyst) {
        alert('Please select both Company and Analyst');
        return;
    }

    setIsSearching(prev => ({ ...prev, [category]: true }));

    try {
        const response = await axios.get('https://tiger-dashboard-server-b0dfb7ddbcfbgnfs.eastus-01.azurewebsites.net/query-top10', {
            params: {
                category,
                analyst,
                company: company,
                query: searchQuery[category]
            },
            withCredentials: false
        });

        setSearchResults(prev => ({
            ...prev,
            [category]: response.data.results
        }));
    } catch (error) {
        console.error('Error searching metrics:', error);
        alert('An error occurred while searching metrics. Please check the console for more details.');
    } finally {
        setIsSearching(prev => ({ ...prev, [category]: false }));
    }
};

const groupRowLabelsByCategory = () => {
    const grouped = [];
    let currentCategory = null;
    let currentGroup = [];

    rowLabels.forEach((row) => {
        if (row.isBold) {
            if (currentCategory) {
                grouped.push({ category: currentCategory, rows: currentGroup });
            }
            currentCategory = row.label;
            currentGroup = [row];
        } else {
            currentGroup.push(row);
        }
    });

    if (currentCategory) {
        grouped.push({ category: currentCategory, rows: currentGroup });
    }

    return grouped;
};

const getColorForDelta = (delta) => {
    if (delta === 'N/A' || delta === 'Inf%') return 'white';
    
    const numericDelta = parseFloat(delta);
    if (isNaN(numericDelta)) return 'white';

    // Define the color stops
    const colorStops = [
        { value: -15, color: [255, 0, 0] },    // Red for large negative
        { value: -5, color: [255, 165, 0] },   // Orange for moderate negative
        { value: 0, color: [255, 255, 0] },    // Yellow for neutral
        { value: 5, color: [144, 238, 144] },  // Light green for moderate positive
        { value: 15, color: [60, 179, 113] }   // Lighter normal green for large positive (medium sea green)
    ];

    // Find the appropriate color range
    let startColor, endColor, startValue, endValue;
    for (let i = 0; i < colorStops.length - 1; i++) {
        if (numericDelta <= colorStops[i + 1].value) {
            startColor = colorStops[i].color;
            endColor = colorStops[i + 1].color;
            startValue = colorStops[i].value;
            endValue = colorStops[i + 1].value;
            break;
        }
    }

    // If the value is beyond the last stop, use the last color
    if (!startColor) {
        return `rgb(${colorStops[colorStops.length - 1].color.join(',')})`;
    }

    // Calculate the color based on the position within the range
    const ratio = (numericDelta - startValue) / (endValue - startValue);
    const r = Math.round(startColor[0] + ratio * (endColor[0] - startColor[0]));
    const g = Math.round(startColor[1] + ratio * (endColor[1] - startColor[1]));
    const b = Math.round(startColor[2] + ratio * (endColor[2] - startColor[2]));

    return `rgb(${r},${g},${b})`;
};

const formatCellValue = (value, category, rowLabel, outputType) => {
    if (outputType !== "value") {
        return value; // Return the original value for non-"value" outputs
    }

    if (value === null || value === undefined || value === '' || value === '-' || value === 'N/A') {
        return '-';
    }

    const numValue = parseFloat(value);

    if (isNaN(numValue)) {
        return value; // Return original value if it's not a number
    }

    if (category === "Margin Analysis" || rowLabel.toLowerCase().includes("margin")) {
        // Format as percentage with 2 decimal places
        return (numValue * 100).toFixed(1) + '%';
    } else {
        // Format as number with comma separators and appropriate decimal places
        if (Math.abs(numValue) >= 1) {
            // For larger numbers, round to nearest whole number
            return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Math.round(numValue));
        } else {
            // For smaller numbers (less than 1), show up to 2 decimal places
            return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(numValue);
        }
    }
};

const calculateDelta = (before, after, category) => {
    if (before === undefined || after === undefined || before === '-' || after === '-' || before === 'N/A' || after === 'N/A') {
        return 'N/A';
    }

    const beforeValue = parseFloat(before);
    const afterValue = parseFloat(after);

    if (isNaN(beforeValue) || isNaN(afterValue)) {
        return 'N/A';
    }

    if (category === "Margin Analysis" || category.toLowerCase().includes("margin")) {
        // For Margin Analysis, calculate absolute percentage point change
        const delta = (afterValue - beforeValue) * 100;
        return delta.toFixed(1) + '%';
    } else {
        // For other categories, calculate relative percentage change
        if (beforeValue === 0) {
            return afterValue === 0 ? '0.0%' : 'Inf%';
        }
        const percentageDelta = ((afterValue - beforeValue) / beforeValue) * 100;
        return percentageDelta.toFixed(1) + '%';
    }
};

const handleCompanyChange = (e) => {
    const newCompany = e.target.value;
    setCompany(newCompany);
    setData(null); // Clear data when changing companies
    setSearchResults({}); // Clear search results
    setSearchQuery({}); // Clear search queries
};

return (
    <div style={{ padding: '1rem' }}>
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginBottom: '1rem'
        }}>
            <img 
                src={logo}
                alt="Formula Insight Logo" 
                style={{
                    width: '275px',
                    height: 'auto',
                    marginRight: '1rem'
                }}
            />
            <div style={{ display: 'flex', gap: '1rem', flexGrow: 1, alignItems: 'center' }}>
                <select
                    value={company}
                    onChange={handleCompanyChange}
                    style={{ padding: '0.5rem' }}
                >
                    <option value="">Select Company</option>
                    <option value="DE US">DE US</option>
                    <option value="ADBE US">ADBE US</option>
                </select>
                <select
                    value={analyst}
                    onChange={(e) => setAnalyst(e.target.value)}
                    style={{ padding: '0.5rem' }}
                >
                    <option value="">Select Analyst</option>
                    <option value="Stefan Raghavan">Stefan Raghavan</option>
                </select>
                <select
                    value={output}
                    onChange={(e) => setOutput(e.target.value)}
                    style={{ padding: '0.5rem' }}
                >
                    <option value="">Select Output</option>
                    <option value="value">Value</option>
                    <option value="source">Source</option>
                    <option value="timestamp">Timestamp</option>
                </select>
                <button
                    onClick={fetchData}
                    disabled={isLoading || isUpdating || !company || !analyst}
                    style={{ 
                        padding: '0.5rem 1rem', 
                        backgroundColor: isLoading || isUpdating || !company || !analyst ? '#cccccc' : 'black', 
                        color: 'white', 
                        border: 'none', 
                        borderRadius: '4px', 
                        cursor: isLoading || isUpdating || !company || !analyst ? 'not-allowed' : 'pointer',
                        fontWeight: 'bold'
                    }}
                >
                    {isLoading ? 'Fetching...' : 'Fetch Data'}
                </button>
                {!dataLoaded && (
                    <span style={{ marginLeft: '1rem', fontSize: '0.9rem', color: '#666' }}>
                        Select a company and analyst, then click "Fetch Data" to see results.
                    </span>
                )}
            </div>
        </div>

        {isLoading && <p>Loading data...</p>}

        {company && (
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: 'auto', borderCollapse: 'separate', borderSpacing: 0, whiteSpace: 'nowrap' }}>
                    {groupRowLabelsByCategory().map((group, groupIndex) => (
                        <React.Fragment key={groupIndex}>
                            <thead>
                                <tr>
                                    <th style={{ 
                                        border: '1px solid transparent',
                                        borderBottom: 'none',
                                        padding: '8px', 
                                        textAlign: 'left', 
                                        position: 'sticky', 
                                        left: 0, 
                                        backgroundColor: 'white', 
                                        zIndex: 1,
                                        fontWeight: 'bold',
                                        fontSize: '1.1em'
                                    }}>
                                        {group.category}
                                    </th>
                                    {columns.map((col) => (
                                        <th key={col.key} colSpan="1" style={{ border: '1px solid transparent', borderBottom: 'none', padding: '4px 8px 2px', textAlign: 'center', minWidth: '100px' }}>
                                            {col.label[0]}
                                        </th>
                                    ))}
                                </tr>
                                <tr>
                                    <th style={{ border: '1px solid transparent', borderTop: 'none', borderBottom: 'none', padding: '2px 8px 4px', textAlign: 'left' }}></th>
                                    {columns.map((col) => (
                                        <th key={col.key} style={{ border: '1px solid transparent', borderTop: 'none', borderBottom: 'none', padding: '2px 8px 4px', textAlign: 'center', minWidth: '100px' }}>
                                            {col.label[1]}
                                        </th>
                                    ))}
                                </tr>
                                <tr>
                                    <th colSpan={columns.length + 1} style={{ padding: 0, height: '2px' }}>
                                        <div style={{ borderBottom: '5px solid black', width: '100%', height: '100%' }}></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {group.rows.filter(row => !row.isBold).map((row, rowIndex) => (
                                    <tr key={`${groupIndex}-${rowIndex}`} style={row.isEmpty ? { height: '20px' } : {}}>
                                        <td 
                                            style={{ 
                                                border: '1px solid transparent',
                                                borderTop: 'none',
                                                padding: '8px', 
                                                textAlign: 'left',
                                                backgroundColor: row.isEmpty ? '#f8f8f8' : 'white',
                                                position: 'sticky',
                                                left: 0,
                                                zIndex: 1,
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}
                                        >
                                            {row.label}
                                            {row.isNew && (
                                                <button
                                                    onClick={() => removeMetric(row.label)}
                                                    style={{
                                                        padding: '2px 5px',
                                                        backgroundColor: '#ff4d4d',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        fontSize: '0.8em'
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                            )}
                                        </td>
                                        {columns.map((col) => {
                                            const isDeltaColumn = col.label[0] === 'Delta';
                                            let cellValue, backgroundColor;
                                        
                                            if (isDeltaColumn && data && data[row.label]) {
                                                const beforeKey = columns[columns.findIndex(c => c.key === col.key) - 2].key;
                                                const afterKey = columns[columns.findIndex(c => c.key === col.key) - 1].key;
                                                const beforeValue = data[row.label][beforeKey];
                                                const afterValue = data[row.label][afterKey];
                                                cellValue = calculateDelta(beforeValue, afterValue, group.category);
                                                backgroundColor = getColorForDelta(cellValue);
                                            } else {
                                                cellValue = data && data[row.label] && data[row.label][col.key] !== undefined 
                                                    ? formatCellValue(data[row.label][col.key], group.category, row.label, output) 
                                                    : '-';
                                                backgroundColor = row.isEmpty ? '#f8f8f8' : 'white';
                                            }
                                            
                                            return (
                                                <td 
                                                    key={col.key} 
                                                    style={{ 
                                                        border: '1px solid transparent',
                                                        borderTop: 'none',
                                                        padding: '8px', 
                                                        textAlign: 'center',
                                                        backgroundColor,
                                                        opacity: isUpdating && newMetrics.some(m => m.metric === row.label) ? 0.5 : 1
                                                    }}
                                                >
                                                    {cellValue}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan={columns.length + 1} style={{ padding: '8px', textAlign: 'left' }}>
                                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search metrics..."
                                                    value={searchQuery[group.category] || ''}
                                                    onChange={(e) => handleSearchQueryChange(group.category, e.target.value)}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            searchMetrics(group.category);
                                                        }
                                                    }}
                                                    style={{ padding: '5px' }}
                                                />
                                                <button
                                                    onClick={() => searchMetrics(group.category)}
                                                    disabled={isSearching[group.category]}
                                                    style={{
                                                        padding: '5px 10px',
                                                        backgroundColor: 'black',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    {isSearching[group.category] ? 'Searching...' : 'Search metric'}
                                                </button>
                                            </div>
                                            {isLoadingMetrics[group.category] ? (
                                                <p>Loading metrics...</p>
                                            ) : (
                                                <div style={{ display: 'flex', gap: '10px' }}>
                                                    <button
                                                        onClick={() => showMetrics[group.category] ? hideMetrics(group.category) : fetchMetrics(group.category)}
                                                        style={{
                                                            padding: '5px 10px',
                                                            backgroundColor: 'black',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        {showMetrics[group.category] ? 'Hide metrics' : 'View metrics'}
                                                    </button>
                                                    <button
                                                        onClick={updateData}
                                                        disabled={isLoading || isUpdating || !company}
                                                        style={{ 
                                                            padding: '5px 10px', 
                                                            backgroundColor: isLoading || isUpdating || !company ? '#cccccc' : '#8B0000',
                                                            color: 'white', 
                                                            border: 'none', 
                                                            borderRadius: '4px', 
                                                            cursor: isLoading || isUpdating || !company ? 'not-allowed' : 'pointer',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        {isUpdating ? 'Updating...' : 'Update Data'}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        {searchResults[group.category] && (
                                            <div style={{ marginBottom: '10px' }}>
                                                <p>Search Results:</p>
                                                <ul style={{ listStyleType: 'none', padding: 0 }}>
                                                    {searchResults[group.category].sort().map(metric => (
                                                        <li key={metric} style={{ marginBottom: '5px' }}>
                                                            <button 
                                                                onClick={() => addMetric(group.category, metric)}
                                                                style={{
                                                                    padding: '5px 10px',
                                                                    backgroundColor: '#f0f0f0',
                                                                    border: '1px solid #ddd',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer',
                                                                    width: '100%',
                                                                    textAlign: 'left'
                                                                }}
                                                            >
                                                                {metric}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                        {showMetrics[group.category] && (
                                            <div style={{ marginTop: '10px' }}>
                                                <p>All Metrics:</p>
                                                <ul style={{ listStyleType: 'none', padding: 0 }}>
                                                    {metrics[group.category] && metrics[group.category].length > 0 ? (
                                                        metrics[group.category].sort().map(metric => (
                                                            <li key={metric} style={{ marginBottom: '5px' }}>
                                                                <button 
                                                                    onClick={() => addMetric(group.category, metric)}
                                                                    style={{
                                                                        padding: '5px 10px',
                                                                        backgroundColor: '#f0f0f0',
                                                                        border: '1px solid #ddd',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer',
                                                                        width: '100%',
                                                                        textAlign: 'left'
                                                                    }}
                                                                >
                                                                    {metric}
                                                                </button>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <li>No metrics available for this category.</li>
                                                    )}
                                                </ul>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </React.Fragment>
                    ))}
                </table>
            </div>
        )}

        {!company && (
            <p></p>
        )}
    </div>
);
};

export default FinancialDashboard;